<template>
  <div id="customers" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex mb-6 flex-wrap gap-4">
          <div class="">
            <div class="dropdown-button-container">
              <vs-dropdown :vs-trigger-click="true">
                <vs-button
                  class="btn-drop vs-component vs-button bg_l_green bg-danger w-full"
                  color="success"
                  icon="add"
                  :vs-trigger-click="true"
                  v-has-permission="permission78"
                  >{{ $t("CreateNewAgent") }}</vs-button
                >
                <vs-dropdown-menu id="agent-dp">
                  <router-link :to="{ path: '/Agents/CreateIndividual' }">
                    <vs-dropdown-item>
                      {{ $t("Individual") }}
                    </vs-dropdown-item>
                  </router-link>
                  <router-link :to="{ path: '/Agents/CreateLegal' }">
                    <vs-dropdown-item>
                      {{ $t("Legal") }}
                    </vs-dropdown-item>
                  </router-link>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="flex-grow flex gap-4 justify-end">
            <div>
              <vs-button
                @click="uploadFileForLegal()"
                class="bg_m_green float-right"
                v-if="fileUploadedForLegal"
                :disabled="disabledBtnForLegal"
                v-has-permission="permission319"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload">
                <input
                  type="file"
                  id="file"
                  ref="fileForLegal"
                  v-on:change="handleFileUploadForLegal()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateLegalAgentWithExcel") }}
                </div>
                <span v-if="uploadedFileNameForLegal" class="file-name">{{
                  uploadedFileNameForLegal
                }}</span>
              </label>
            </div>
            <div>
              <vs-button
                @click="uploadFileForIndividual()"
                class="bg_m_green float-right"
                v-if="fileUploadedForIndividual"
                :disabled="disabledBtn"
                v-has-permission="permission320"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Submit") }}
              </vs-button>
              <label class="custom-file-upload">
                <input
                  type="file"
                  id="file"
                  ref="fileForIndividual"
                  v-on:change="handleFileUploadForIndividual()"
                />
                <div class="flex gap-2 items-start">
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />{{ $t("CreateIndividualAgentWithExcel") }}
                </div>
                <span v-if="uploadedFileNameForIndividual" class="file-name">{{
                  uploadedFileNameForIndividual
                }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <div class="flex-col w-full">
              <vx-card class="mt-2">
                <vs-tabs vs-alignment="fixed" alignment="fixed">
                  <vs-tab :label="$t('WaitingForConfirm')">
                    <waiting-for-confirm></waiting-for-confirm>
                  </vs-tab>
                  <vs-tab :label="$t('Confirmed')">
                    <confirmed></confirmed>
                  </vs-tab>
                  <vs-tab :label="$t('Rejected')">
                    <rejected></rejected>
                  </vs-tab>
                </vs-tabs>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  border-radius: 6px 0 0 6px !important;
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
}
.bg_l_green {
  cursor: pointer;
}

</style>
<script>
import { mapActions } from "vuex";
import WaitingForConfirm from "./WaitingForConfirm.vue";
import Confirmed from "./Confirmed.vue";
import Rejected from "./Rejected.vue";

export default {
  data() {
    return {
      permission319: "CreateAgentLegalByExcelFile",
      permission320: "CreateAgentIndividualByExcelFile",
      permission78: "CreateAgentLegal|CreateAgentIndividual",
      permission240: "GetAllByAgentInfo",
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/AgentsInfoQuery",
      },
      gridSearchData: {
        AgentState: 1,
      },
      customers: [
        { name: "حقیقی", id: 1 },
        { name: "حقوقی", id: 2 },
      ],
      fileForLegal: "",
      fileForIndividual: "",
      fileUploadedForLegal: false,
      disabledBtnForLegal: false,
      uploadedFileNameForLegal: "",
      fileUploadedForIndividual: false,
      disabledBtnForIndividual: false,
      isShowUserPopup: false,
      isShowAgentSegmentPopup: false,
      isShowAgentBranchPopup: false,
      isShowSalesPersonsPopup: false,
      uploadedFileNameForIndividual: "",
      emptyFileInRefs: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = null;
  },
  methods: {
    ...mapActions({
      importAgentIndividuals: "excel/importAgentIndividuals",
      importAgentLegals: "excel/importAgentLegals",
    }),


    handleFileUploadForLegal() {
      this.fileForLegal = this.$refs.fileForLegal.files[0];
      this.uploadedFileNameForLegal = this.fileForLegal.name;
      this.fileUploadedForLegal = true;
    },
    handleFileUploadForIndividual() {
      this.fileForIndividual = this.$refs.fileForIndividual.files[0];
      this.uploadedFileNameForIndividual = this.fileForIndividual.name;
      this.fileUploadedForIndividual = true;
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    uploadFileForLegal() {
      this.disabledBtnForLegal = true;
      let formData = new FormData();
      formData.append("file", this.fileForLegal);
      this.importAgentLegals(formData).then(() => {
        this.successRequestImportExcel();
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtnForLegal = false;
      }, 1000);
    },

    uploadFileForIndividual() {
      this.disabledBtnForIndividual = true;
      let formData = new FormData();
      formData.append("file", this.fileForIndividual);
      this.importAgentIndividuals(formData).then(() => {
        this.successRequestImportExcel();
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtnForIndividual = false;
      }, 1000);
    },
    successRequestImportExcel() {
      this.fileUploadedForLegal = false;
      this.fileUploadedForIndividual = false;

      setTimeout(() => {
        this.$refs.grid.renderGrid();
        this.uploadedFileNameForLegal = "";
        this.uploadedFileNameForIndividual = "";
      }, 5000);
    },
  },
  components: {
    WaitingForConfirm,
    Confirmed,
    Rejected,
  },
};
</script>
